import PeopleIcon from "@mui/icons-material/People";
import { IconButton, Tooltip } from "@mui/material";
import useBoolean from "hooks/useBoolean";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { WebinarExtended } from "services/KnowfullyAdminClient";
import processAttendanceStore from "stores/processAttendanceStore";

type ProcessAttendanceButtonProps = {
  webinar: WebinarExtended;
  onClick: React.MouseEventHandler;
};

const ProcessAttendanceButton = ({
  webinar,
  onClick,
}: ProcessAttendanceButtonProps) => {
  const isFutureWebinar = webinar.timeToEnableProcessAttendance! > 0;
  const { formatMessage: t } = useIntl();
  const { processAttendanceData } = processAttendanceStore.useState();
  const [buttonIsDisabled, buttonIsDisabledSetter] = useBoolean(
    isFutureWebinar
  );

  const processAttendanceExecuted =
    processAttendanceData.some(
      (x) =>
        x.skuId === webinar.skuId && x.organizationId === webinar.organizationId
    ) || webinar.attendanceProcessingCompleted;

  useEffect(() => {
    if (isFutureWebinar) {
      var timer = setTimeout(() => {
        buttonIsDisabledSetter.setFalse();
      }, webinar.timeToEnableProcessAttendance);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [
    webinar.timeToEnableProcessAttendance,
    buttonIsDisabledSetter,
    isFutureWebinar,
  ]);

  return (
    <Tooltip title={t({ id: "processAttendanceLabel" })}>
      <span>
        <IconButton
          size="small"
          sx={{
            color: !processAttendanceExecuted ? "darkblue" : "lightgray",
          }}
          disabled={processAttendanceExecuted || buttonIsDisabled}
          onClick={onClick}
        >
          <PeopleIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ProcessAttendanceButton;
